import type { RegularizationRequest } from '../types/hrmsAttendanceDetails.types'

export const MOCK_REGULARIZATION_REQUESTS: Record<string, RegularizationRequest> = {}

export const SOURCE_NOTES = {
  Biometric: 'Automatically synced from biometric attendance.',
  'Manual Import': 'Imported manually by HR/Admin.',
  None: 'No attendance source recorded for this date.',
}

const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

export function formatTime12h(timeStr?: string): string {
  if (!timeStr || timeStr === 'none') return '—'
  const [hStr, mStr] = timeStr.split(':')
  const h = parseInt(hStr, 10)
  const m = parseInt(mStr, 10)
  if (isNaN(h) || isNaN(m)) return timeStr
  const period = h >= 12 ? 'PM' : 'AM'
  const displayH = h % 12 === 0 ? 12 : h % 12
  const formattedH = displayH < 10 ? `0${displayH}` : `${displayH}`
  const formattedM = m < 10 ? `0${m}` : `${m}`
  return `${formattedH}:${formattedM} ${period}`
}

export function formatWorkingHours(minutes?: number): string {
  if (minutes === undefined || minutes === null) return '—'
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  return `${hours}h ${mins}m`
}

export function formatDateDisplay(dateStr?: string): string {
  if (!dateStr) return '—'
  const parts = dateStr.split('-')
  if (parts.length !== 3) return dateStr
  const y = parseInt(parts[0], 10)
  const m = parseInt(parts[1], 10)
  const d = parseInt(parts[2], 10)
  if (isNaN(y) || isNaN(m) || isNaN(d)) return dateStr
  const monthName = MONTH_NAMES[m - 1] || `${m}`
  const dayPadded = d < 10 ? `0${d}` : `${d}`
  return `${dayPadded} ${monthName} ${y}`
}

export function formatDateTimeDisplay(isoStr?: string): string {
  if (!isoStr) return '—'
  const [datePart, timePart] = isoStr.split('T')
  if (!datePart) return isoStr
  const dateFormatted = formatDateDisplay(datePart)
  if (!timePart) return dateFormatted
  const timeFormatted = formatTime12h(timePart.slice(0, 5))
  return `${dateFormatted}, ${timeFormatted}`
}

export function formatIsoUtcToLocal(isoStr?: string | null): string {
  if (!isoStr) return '—'
  const d = new Date(isoStr)
  if (isNaN(d.getTime())) return '—'
  const day = String(d.getDate()).padStart(2, '0')
  const month = MONTH_NAMES[d.getMonth()] || ''
  const year = d.getFullYear()
  let hours = d.getHours()
  const minutes = String(d.getMinutes()).padStart(2, '0')
  const period = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12 || 12
  const hoursStr = String(hours).padStart(2, '0')
  return `${day} ${month} ${year}, ${hoursStr}:${minutes} ${period}`
}
